var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('v-alert',{class:_vm.alertClass,attrs:{"dense":"","text":"","type":_vm.type,"icon":_vm.icon}},[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }